/*
 * @Author: 肖玲
 * @Date: 2023-02-28 16:02:15
 * @LastEditTime: 2023-02-28 18:27:56
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\channel-delivery-manage\modules\industrialMaintenRouter.js
 * 工业维护路由
 */
const industrialMaintenRouter = [
  // 行为管理 工业信息维护
  {
    path: '/flowSystem/industrial-msg-maintain',
    name: 'behaviorManageIndustrialMsgMaintain',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageIndustrialMsgMaintain" */
      //   '@/views/behaviorManage/ditchDeliver/IndustrialMsgMaintain.vue'
      // ),   待删除文件
    import(
      /*webpackChunkName:"behaviorManageIndustrialMsgMaintain" */
      '@/views/butterfly-flow-system/channel-delivery-manage/industrial-mainten/Industrial-information-mainten/Page.vue'
    ),  //新迁移文件
    meta: {
      SecondaryMenu: '工业维护', //二级菜单
      title: '工业信息维护',
    },
  },
  // 行为管理 工业信息维护 添加工业
  {
    path: '/flowSystem/industrial-add-redact/:json',
    name: 'flowSystemIndustrialAddRedact',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemIndustrialAliasAddRedact" */
      //   '@/views/behaviorManage/ditchDeliver/IndustrialAddRedact.vue'
      // ),  待删除文件
    import(
      /*webpackChunkName:"flowSystemIndustrialAliasAddRedact" */
      '@/views/butterfly-flow-system/channel-delivery-manage/industrial-mainten/Industrial-information-mainten/Add.vue'
    ),   //新迁移文件
    meta: {
      SecondaryMenu: '工业维护', //二级菜单
      title: '添加工业',
      breadcrumb: [{
        title: '工业信息维护',
        name: 'behaviorManageIndustrialMsgMaintain',
      }, ],
    },
  },
]
export default industrialMaintenRouter